import ED40 from "./ED40.jpg";
import ED55 from "./ED55.jpg";
import ED75 from "./ED75.jpg";
import ED90 from "./ED90.jpg";
import ED110 from "./ED110.jpg";
import ED135 from "./ED135.jpg";
import ED999 from "./EDInfoNoCompassFix2.jpg";
import EN40 from "./EN40.jpg";
import EN55 from "./EN55.jpg";
import EN75 from "./EN75.jpg";
import EN90 from "./EN90.jpg";
import EN110 from "./EN110.jpg";
import EN135 from "./EN135.jpg";
import EN999 from "./ENInfoNoCompassFix2.jpg";

import WD40 from "./WD40.jpg";
import WD55 from "./WD55.jpg";
import WD75 from "./WD75.jpg";
import WD90 from "./WD90.jpg";
import WD110 from "./WD110.jpg";
import WD135 from "./WD135.jpg";
import WD999 from "./WDInfoNoCompassFix2.jpg";
import WN40 from "./WN40.jpg";
import WN55 from "./WN55.jpg";
import WN75 from "./WN75.jpg";
import WN90 from "./WN90.jpg";
import WN110 from "./WN110.jpg";
import WN135 from "./WN135.jpg";
import WN999 from "./WNInfoNoCompassFix2.jpg";

export const EAST: Record<string, any> = {
  day: {
    "Floor 10": ED40,
    "Floor 15": ED55,
    "Floor 20": ED75,
    "Floor 25": ED90,
    "Floor 30": ED110,
    "Floor 36": ED135,
    Neighbourhood: ED999,
  },
  night: {
    "Floor 10": EN40,
    "Floor 15": EN55,
    "Floor 20": EN75,
    "Floor 25": EN90,
    "Floor 30": EN110,
    "Floor 36": EN135,
    Neighbourhood: EN999,
  },
};
export const WEST = {
  day: {
    "Floor 10": WD40,
    "Floor 15": WD55,
    "Floor 20": WD75,
    "Floor 25": WD90,
    "Floor 30": WD110,
    "Floor 36": WD135,
    Neighbourhood: WD999,
  },
  night: {
    "Floor 10": WN40,
    "Floor 15": WN55,
    "Floor 20": WN75,
    "Floor 25": WN90,
    "Floor 30": WN110,
    "Floor 36": WN135,
    Neighbourhood: WN999,
  },
};
